enum topBarConstants {
  COACH_DIRECTORY = 'Coach Directory',
}
export default topBarConstants;
